import React from "react";
import classNames from "classnames";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { useAuthentication } from "@planzone/view-models";
import { MemberAvatar } from "@common/memberAvatar";
import { Props } from "./types";
import assistantIcon from "@scenes/assistantShortcut/icon.png";
import styles from "./styles.scss";

function MessageBubble({ message }: Props) {
  const { account } = useAuthentication();
  const isUser = message.role === "user";

  return (
    <div
      className={classNames(styles.messageBubble, {
        [styles.user]: isUser,
        [styles.bot]: !isUser,
      })}
    >
      <div className={styles.avatar}>
        {isUser ? (
          <MemberAvatar
            name={account.resource.name}
            avatarUrl={account.resource.avatarUrl}
          />
        ) : (
          <img src={assistantIcon} className={styles.assistantAvatar} />
        )}
      </div>
      <div className={styles.content}>
        <ReactMarkdown remarkPlugins={[remarkGfm]}>
          {message.content}
        </ReactMarkdown>
      </div>
    </div>
  );
}

export { MessageBubble };
